<div class="loading" *ngIf="isLoading">Loading&#8230;</div>
<h1>Reports</h1>
<a style="text-decoration: underline;" mdbWavesEffect href="sentMessageCount" routerLink="sentMessageCount" >Sent Message Count</a>